import React from 'react';
import { Content } from 'antd/es/layout/layout';

import { APIProvider ,
    Map,
    AdvancedMarker,
    Pin,
    
} from '@vis.gl/react-google-maps';
import { useLoadScript } from '@react-google-maps/api';
import PAQ from './shop-front-component/PAQ';
import { CFCDN } from './shop-front-component/ProductCollection';
const YOUR_GOOGLE_MAPS_API_KEY = "AIzaSyCYPd-Nq5MDCuZrU6gVCnWQNd82a1Ra9oc"
export default function Contact() {
    const {isLoaded} = useLoadScript({ googleMapsApiKey: YOUR_GOOGLE_MAPS_API_KEY, libraries: ['places'], })
  return (
    <div className='hedvig-letters-sans-regular bg-white p-1 mt-20'>
      <Content className=' bg-transparent'>
      <div className='m-auto relative flex justify-center items-center w-full h-[30rem]  overflow-hidden max-w-screen-2xl rounded-md mt-5 shadow-md'>
          <div className="absolute top-0 left-0 h-full w-full bg-black opacity-50"></div>
          <div className='absolute top-1/2 transform flex flex-col text-center'>
            <span className="text-white text-3xl lg:text-6xl font-bold hedvig-letters-serif-regular">Contact Us</span>
          </div>
          <img
            src={CFCDN + "contact-us-cover.jpeg"}
            alt="Centered Image"
            className="object-center object-cover w-full h-full"
          />
        </div>
        <div className='m-auto max-w-screen-2xl flex flex-col lg:flex-row items-center justify-between overflow-hidden h-fit px-10 mt-10 gap-y-10'>
          <div className='flex flex-col items-center w-11/12 lg:w-1/3'>
            <img
              className="object-center h-[3rem] mb-5"
              alt='sign up'
              src={CFCDN + "telephone.png"}>
            </img>
            <span className='font-semibold text-xl text-center '>Phone</span>
            <span className='text-xl  text-neutral-500 text-center underline'>0404 431 431</span>
          </div>
          <div className='flex flex-col items-center w-11/12 lg:w-1/3'>
            <img
              className="object-center h-[3rem] mb-5"
              alt='fabric'
              src={CFCDN + "envelope.png"}>
            </img>
            <span className='font-semibold text-xl text-center'>Email</span>
            <span className='text-xl  text-neutral-500 text-center underline'>sales@allin1.com.au</span>
          </div>
          <div className='flex flex-col items-center w-11/12 lg:w-1/3'>
            <img
              className="object-center h-[3rem] mb-5"
              alt='fabric'
              src={CFCDN + "time.png"}>
            </img>
            <span className='font-semibold text-xl text-center'>Operation Hour</span>
            <span className='text-xl  text-neutral-500 text-center underline '>Mon - Sat: 8am - 5pm</span>
          </div>
        </div>

        <div className="m-auto relative flex flex-col-reverse px-5 lg:px-0 lg:flex-row justify-between items-center max-w-screen-2xl rounded-md mt-20 mb-20 gap-20 lg:gap-0">
          {/* Left Section with map */}
         
              {isLoaded && <APIProvider
                apiKey= {YOUR_GOOGLE_MAPS_API_KEY}
              >
                <div className='bg-neutral-500 flex rounded-md h-[30rem] w-full lg:w-1/2  shadow-md overflow-hidden border-none'>
                  <Map 
                 
                  zoom={15} 
                  mapTypeControl ={false}
                  streetViewControl ={false}
                  fullscreenControl = {false}
                  center={{ lat: -33.91103887179641, lng: 150.92414494034978 }} 
                  mapId={'63b035ffd001819d'}
                  >
                    <AdvancedMarker position={{ lat: -33.91103887179641, lng: 150.92414494034978 }}></AdvancedMarker>
                  </Map>
                </div>
              </APIProvider>}
         
          {/* Right Section with address and invitational text */}
          <div className='h-[30rem] w-full lg:w-1/2 lg:px-10 py-5 flex flex-col text-left'>
            <span className='text-3xl mb-6 text-neutral-500 '>Our Location</span>
            <span className='text-5xl font-bold mb-6 hedvig-letters-serif-regular'>Come Visit Us!</span>
            <p className='text-xl text-neutral-500 text-left'>
              Swing by our shop and check out our premium samples in person, and experience firsthand the quality and craftsmanship that sets us apart! Our friendly team is here to help you find exactly what you need.
            </p>
            <div className='flex flex-row gap-1 items-center  mt-8'>
              <img
                className="object-center h-[2rem] mb-5"
                alt='fabric'
                src={CFCDN + "pin.png"}>
              </img>
              <span className='text-2xl mb-4 underline'>157 Lawrence Hargrave Rd, Warwick Farm NSW 2170</span>
            </div>
          </div>
        </div>
        
        <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20'>
            <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                Frequently Asked Questions
            </span>
            
        </div>
        <PAQ></PAQ>
        
      </Content>
    </div>
  )
}
